import { Theme } from "@mui/material";
import React from "react";

const useStyles = (theme: Theme) => ({
  modal: { display: "flex", justifyContent: "center", alignItems: "center" },
  paper: {
    padding: 2,
    maxWidth: "432px",
    width: "90%",
    minWidth: "232px",
    maxHeight: "90vh",
    gap: 2,
    flexDirection: "column",
    display: "flex",
    alignItems: "felx-start",
  },
  boxHeader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "start",
    gap: 2,
    width: "100%",
  },
  boxContent: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    width: "100%",
    paddingTop: 2,
  },
  boxActions: {
    display: "flex",
    flexDirection: "row",
    paddingTop: 2,
    gap: 2,
    justifyContent: "flex-end",
    alignItems: "center",
    width: "100%",
  },
});

export default useStyles;
